import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SubcriptionExpired from 'routing/SubcriptionExpired';

// @ts-ignore
const PrivateRoute = ({component: Component, ...rest}) => {
  const { data = {} } = useSelector((state: any) => state.user);
  const { profile } = useSelector((state: any) => state.account);

  return (
    <Route {...rest} render={props => (
      data.access_token ? 
        <Component {...props} />
      : <Redirect to="/login" />
    )} />
  );
};

export default PrivateRoute;